import { Text } from "@/components/ui/baseUi/text"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/baseUi/tooltip"
import { ResumeCardPriceDisplay } from "@/modules/finances/components/resumeCardPriceDisplay"
import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { FinanceStatisticsEntity } from "@modules/finances/entities/financeStatisticsEntity"
import { CircleQuestionMarkIcon } from "lucide-react"

type Props = {
  stats?: FinanceStatisticsEntity | null
  className?: string
} & React.ComponentProps<"div">

export function PayoutTotalTransferCard({ stats, className, ...props }: Props) {
  const payoutTotalAmount = stats?.stats.payoutTotalAmount ?? 0

  return (
    <div
      className={cn(
        "flex h-45 max-w-75 flex-col justify-between gap-2 overflow-hidden rounded-4xl bg-surface-background-secondary p-4 md:p-6",
        className,
      )}
      {...props}
    >
      <Text fontStyle="TL">{word("finances.payouts.card.totalSinceRegistration.title")}</Text>

      <div className="flex w-full flex-row items-center justify-between">
        {/* TOTAL AMOUNT */}
        <div className="flex flex-row items-center gap-1">
          <ResumeCardPriceDisplay
            price={{ value: payoutTotalAmount, currency: stats?.stats.currency ?? "" }}
            wholePartFontStyle="HM"
            decimalPartFontStyle="TL"
            wholePartClassName={payoutTotalAmount > 0 ? "text-textOnSurface-positive" : "text-textOnSurface-subtle"}
            decimalPartClassName={payoutTotalAmount > 0 ? "text-textOnSurface-positive" : "text-textOnSurface-subtle"}
          />
          <Tooltip>
            <TooltipTrigger render={<CircleQuestionMarkIcon color="currentColor" className="size-4" />} />
            <TooltipContent side="bottom" className="flex max-w-80 flex-col wrap-break-word whitespace-break-spaces">
              <Text fontStyle="BM">{word("finances.payouts.card.totalSinceRegistration.tooltipText")}</Text>
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
